import React from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {routes} from "../../../../../../core/models/static/routes/app-routes";
import BackOrdersList from "./list";
import SalesOrderInformationView from "../sales-orders/single";
import useAccessLevels from "../../../../../hooks/use-access-levels";


const BackOrderViews = () => {
    const operatorAccessLevels = useAccessLevels();

    return (
        <Switch>
            {
                operatorAccessLevels.packages.sales.salesOrderInformation &&
                <Route path={[routes.customer.sales.backOrder.single]} exact>
                    <SalesOrderInformationView/>
                </Route>
            }
            {
                operatorAccessLevels.packages.sales.salesOrdersList &&
                <Route path={[
                    routes.customer.sales.backOrder.base,
                    routes.sales.backOrder
                ]} exact>
                    <BackOrdersList/>
                </Route>
            }
            <Redirect to={routes.sales.backOrder.concat(routes.error.serverErrorForSection)}/>
        </Switch>
    );
};

export default BackOrderViews;
